var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentGroup)?_c('div',[_c('banner-small',{attrs:{"group":_vm.currentGroup,"title":"Virtual Assistant"}}),_vm._v(" "),_c('virtual-assistant',{attrs:{"id":_vm.currentGroup.id,"type":"group"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }